import { pxToRem, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  border: solid ${pxToRem(1)} ${themeGet('colors.border.100')};
  border-radius: ${themeGet('borderRadius.md')};
  padding: ${themeGet('spacing.lg')};
`;
export const Divider = styled.div `
  width: 100%;
  height: ${pxToRem(1)};
  background-color: ${themeGet('colors.border.100')};
`;
